import  { useState } from 'react'

export default function ChangePassword({ user }){
    const [currentPassword, setCurrentPassword] = useState('25052000');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        if(currentPassword === '25052000'){
            if(currentPassword === newPassword){
                setErrorPassword("Le nouveau mot de passe doit etre  different de l'ancien");
            } else{
                if( newPassword === confirmPassword){
                    // setSubmitted(true);
                    // setErrorPassword(false);
                }else{
                    setErrorPassword('Les mots de passe ne correspondent pas');
                }
            }
        } else{
            setErrorPassword('Mot de passe est incorrect');
        }
    };

    return(
        <form onSubmit={handleSubmit}>
            <div className="border-b border-gray-900/10 pb-8">
                <h2 className="text-base font-semibold leading-7 text-gray-900">Change le mot de passe</h2>
                <p className="mt-1 text-sm leading-6 text-gray-600">Mettez à jour votre mot de passe associé à votre compte.</p>

                <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                    <div className="sm:col-span-full">
                        <label htmlFor="current-password" className="block text-sm font-medium leading-6 text-gray-900">
                            Mot de passe actuel
                        </label>
                        <div className="mt-2">
                        <input
                            type="password"
                            name="current-password"
                            id="current-password"
                            autoComplete="current-password"
                            value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className="sm:col-span-full">
                    <label htmlFor="new-password" className="block text-sm font-medium leading-6 text-gray-900">
                        Nouveau mot de passe
                    </label>
                    <div className="mt-2">
                        <input
                            type="password"
                            name="new-password"
                            id="new-password"
                            autoComplete="new-password"
                            value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className="sm:col-span-full">
                    <label htmlFor="confirm-password" className="block text-sm font-medium leading-6 text-gray-900">
                        Confirmez le mot de passe
                    </label>
                    <div className="mt-2">
                        <input
                            type="password"
                           name="confirm-password"
                            id="confirm-password"
                            autoComplete="confirm-password"
                            value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                {errorPassword && <p className='text-red-600 px-2 text-sm sm:col-span-full'>* {errorPassword}</p>}
                
            </div>
            </div>
            <div className="mt-6 flex items-center justify-end gap-x-6">
                <button
                    type="submit"
                    className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
                    >
                    Sauvegarder
                </button>
            </div>
        </form>
    )
}